<template>
  <DatePicker v-model="date" :label="$tt('birth_date')" past />
</template>

<script setup lang="ts">
import type { DateISO } from '~/types';

const date = defineModel<DateISO>({ required: true });
</script>